// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class AssortmentShare extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon viewBox="0 0 24 24" {...this.props}>
                <path d="M20,11h-4c-0.6,0-1,0.4-1,1s0.4,1,1,1h3l0,9H5v-9h3c0.6,0,1-0.4,1-1s-0.4-1-1-1H4c-0.6,0-1,0.4-1,1v11c0,0.6,0.4,1,1,1h16c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7l0-11C21,11.4,20.5,11,20,11z" />
                <path d="M23.9,5.4c0.1-0.2,0.1-0.5,0-0.8c-0.1-0.1-0.1-0.2-0.2-0.3l-4-4c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L20.6,4H17c-5.3,0-6,5.3-6,10v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4c0-7.4,2.1-8,4-8h3.6l-2.3,2.3c-0.4,0.4-0.4,1,0,1.4C18.5,9.9,18.7,10,19,10s0.5-0.1,0.7-0.3l4-4C23.8,5.6,23.9,5.5,23.9,5.4z" />
            </SvgIcon>
        );
    }
}
